/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import './Navigation.css';
import logo from '../../assets/images/logo-in-menu-w.png';
import logoDark from '../../assets/images/logo-in-menu-b.png';
import Address from '../common/Address';
import Web3Ctx from '../Context/Web3Ctx';

const Navigation = (props)=>{
    const [toggleNav, setToggleNav] = useState(false);
    const {onboard, address, connecting} = useContext(Web3Ctx);

    useEffect(()=>{

    },[]);



    const handleConnect = async () => {
 

            if (onboard) {
                onboard.walletReset();
                const selected = await onboard.walletSelect().catch((e)=>{console.log(e)});
                console.log('selected', selected);
                if(selected){
                   await  onboard.walletCheck();
                }
            }
    }

    const handleDisconnect = () => {
        // console.log('disconnect clicked');
        if (onboard) {
            onboard.walletReset();
            if (localStorage) {
                localStorage.removeItem('selectedWallet');
            }
        }
    }


    const   handleToggleNav = () => {
        setToggleNav(!toggleNav);
    }
 

    return (
        <nav className={`navbar navbar-expand-lg ${props.mode&&props.mode==='light'?'navbar-light':'navbar-dark'} ${props.className}`}>
       
        <div className="container">
                <a className="navbar-brand nav-link el" href="https://ether.cards"><img src={props.mode&&props.mode==='light'?logoDark:logo} alt="toolbox"/></a>
                <button className="navbar-toggler" type="button" onClick={handleToggleNav}>
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse ${toggleNav?'show':''} navbar-collapse text-right`} id="navbarText">
                    <ul className="navbar-nav ml-auto mr-3">
          
                        <li className="nav-item dw">
                            <NavLink className="nav-link" to="/">POOLS</NavLink>
                       </li>

                        <li className="nav-item dw">
                            <a className="nav-link" href="https://explorer.ether.cards/#/wallet">WALLET</a>
                       </li>

                        {!connecting && <>
                            {address ?
                                    <li className="nav-item ml-4 address">
                                        <Address address={address} short blockie scale={3}/>
                                        <p className="disconnect" onClick={handleDisconnect}>disconnect</p>
                                    </li>
                            :
                                    <li className="nav-item ml-4">
                                        <button className={`btn btn-pool ${props.mode&&props.mode==='light'?'black':'orange'} outline  outline`} onClick={handleConnect}>connect to wallet</button>
                                    </li>
                            }
                    </>}

                    </ul>
                    
                </div>
        </div>
            </nav>
    );

}
export default Navigation;
